export * from './isPlatformPaySupported'
